<template>
  <div class="vacancy-card-new__main">
    <div class="vacancy-card-new__content">
      <div class="vacancy-card-new__header">
        <div v-if="vacancy.is_hot"
             class="vacancy-card-new__label">
          <BaseSvg name="ico-hot"/>
        </div>
        <div class="vacancy-card-new__id ">ID: {{ vacancy.ID }}</div>
        <div v-if="vacancy[3].work_place_city"
             class="vacancy-card-new__vacancy-city">
          <BaseSvg name="ico-map-marker"/>
          {{ vacancy[3].work_place_city.name }}
        </div>
      </div>

      <div class="vacancy-card-new__title">
        <router-link-modified
            :to="{
            name: 'vacancy',
            params: {
              vacancyId: (vacancy[1] || {}).slug
            }
          }"
        >
          {{ (vacancy[1] || {}).name }}
        </router-link-modified>
      </div>

      <VacancyCardBenefits :vacancy="vacancy"
                           class="vacancy-card-new__benefits"/>

      <VacancyCardCategories class="vacancy-card-new__categories"
                             v-if="vacancy[1] && vacancy[1].categories.length"
                             :vacancy="vacancy[1]"/>

      <VacancyCardInfoSalary :section="vacancy[1]" class="_no-link"/>
    </div>

    <VacancyCardEmployer v-if="employer"
                         class="vacancy-card-new__side-mob"
                         rating
                         :employer="employer"/>

    <VacancyCardAction
        class="vacancy-card-new__action  _no-link"
        :vacancy="vacancy"
    />
  </div>
</template>

<script>
  import VacancyCardAction from '@/components/vacancy-card/VacancyCardAction'
  import VacancyCardEmployer from '@/components/vacancy-card/VacancyCardEmployer'
  import VacancyCardCategories from '@/components/vacancy-card/VacancyCardCategories'
  import VacancyCardBenefits from "@/components/vacancy-card/VacancyCardBenefits"
  import VacancyCardInfoSalary from "@/components/vacancy-card/VacancyCardInfoSalary"

  export default {
    name: 'VacancyCardInfo',

    components: {
      VacancyCardCategories,
      VacancyCardAction,
      VacancyCardEmployer,
      VacancyCardBenefits,
      VacancyCardInfoSalary,
    },

    props: {
      vacancy: {
        type: Object,
        required: true
      },
      employer: {
        type: Object,
      }
    },

    computed: {}
  }
</script>
